import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { memo } from 'react';
import SortingFilter from '../../../Filters/SortingFilter';
import { CarRentalSortingValues, FiltersInitialValue } from '../../../../constants';
import { carSearch } from '../../../../store/slices/car';
import { setCarTripSearchParam } from '../../../../store/slices/tripSearch';

const CarsSorting = ({ tripId, selectedTab }) => {
  const dispatch = useDispatch();
  const SortingValues = CarRentalSortingValues;
  const InitialSortValue = FiltersInitialValue.car.sortBy;
  const { sortBy, sortDirection } = useSelector((store) => store.tripSearch.searchObj.car);
  const search = (obj) => {
    const o = obj;
    dispatch(setCarTripSearchParam(o));
    dispatch(
      carSearch({
        tripId,
        selectedTab,
      }),
    );
  };
  return (
    <SortingFilter
      sortingValues={SortingValues}
      initialValue={InitialSortValue}
      value={sortBy}
      direction={sortDirection}
      onSortChange={search}
      resultsLabel="cars"
      variant="outline"
      filterSpacingClass="py-2 px-3"
      fontSize="text-base"
    />
  );
};

CarsSorting.propTypes = {
  tripId: PropTypes.string.isRequired,
  selectedTab: PropTypes.number.isRequired,
};

export default memo(CarsSorting);
